const PATTERNS = [
  // Static keys
  'ajs_user_id=',
  'ajs_anonymous_id=',
  'ajs_group_id=',
  '_ga=',
  'hackedu.logged.in.app=',
  // Dynamic keys
  'amplitude_id',
  'intercom-',
  'mp_[0-9\\w]+mixpanel=',
  'hubspotutk',
  'hubspotuk',
  'gcl_au',
  '_fbp',
  '_hjid',
  '__hssrc',
  '_gid',
]

const HEADERS = {
  'sec-fetch-user': true,
  'sec-fetch-mode': true,
  'sec-fetch-site': true,
  'sec-fetch-dest': true,
  'x-amzn-trace-id': true,
}

export const removeCookiesKeys = (text = '', patterns = PATTERNS) => {
  let regText = ''
  regText = PATTERNS.join('|')

  const cookiesList = text.split(';')
  const re = new RegExp(`(${regText})`)

  return cookiesList.filter((cookie) => {
    return !re.test(cookie)
  }).join(';')
}

export const removeHeader = (text = '', patterns = HEADERS) => {
  const regText = patterns.join('.+|')
  const re = new RegExp(`(${regText}.+)`, 'g')
  return text.match(re)
}

export const cleanObjectRequest = (request) => ({
  ...request,
  headers: Object.keys(request.headers).reduce((prev, curr) => {
    if (!HEADERS[curr]) {
      prev[curr] = request.headers[curr]
    }
    if (curr === 'cookie') {
      prev[curr] = removeCookiesKeys(request.headers[curr])
      if (typeof prev[curr] === 'string' && prev[curr].trim() === '') {
        delete prev[curr]
      }
    }
    return prev
  }, {}),
})
